import React, { FC } from "react";
import { defineMessages, useIntl } from "react-intl";
import { Button } from "@natera/form";
import { Svg } from "@natera/material/lib/svg";
import AccountNotAvailable from "@assets/svg/account_not_available.svg";
import acknowledgements from "@etc/acknowledgements.json";

import "./upsDobVerificationFailed.scss";

const messages = defineMessages({
  title: {
    id: "upsDobVerificationFailedTitle",
    defaultMessage: "We are unable to verify your date of birth",
  },
  description: {
    id: "upsDobVerificationFailedDescription",
    defaultMessage:
      "It is possible that your clinic gave us the wrong date of birth, or that it was entered incorrectly. Please click the button below to create your account.",
  },
  createAccount: {
    id: "upsDobVerificationFailedCreateAccount",
    defaultMessage: "Create account",
  },
  issues: {
    id: "upsDobVerificationFailedIssues",
    defaultMessage: "Having issues with verification? {contactUs}",
  },
  contactUs: {
    id: "upsDobVerificationFailedContactUs",
    defaultMessage: "Contact Us",
  },
});

interface Props {
  onCreateAccount?: () => void;
}

const UPSDobVerificationFailed: FC<Props> = ({ onCreateAccount }) => {
  const intl = useIntl();

  const handleCreateAccount = () => {
    if (onCreateAccount) {
      onCreateAccount();
    }
  };

  return (
    <div className="ups-dob-verification-failed__wrapper">
      <div className="ups-dob-verification-failed__card">
        <section className="ups-dob-verification-failed__content">
          <Svg content={AccountNotAvailable} />
          <h2 className="ups-dob-verification-failed__title">
            {intl.formatMessage(messages.title)}
          </h2>
          <p className="ups-dob-verification-failed__description">
            {intl.formatMessage(messages.description)}
          </p>
          <Button
            className="ups-dob-verification-failed__create-account"
            unelevated
            onClick={handleCreateAccount}
          >
            {intl.formatMessage(messages.createAccount)}
          </Button>
          <p className="ups-dob-verification-failed__bottom-text">
            {intl.formatMessage(messages.issues, {
              contactUs: (
                <a
                  target="_blank"
                  key="contactUs"
                  rel="noreferrer"
                  href={acknowledgements.links.contactUs}
                >
                  {intl.formatMessage(messages.contactUs)}
                </a>
              ),
            })}
          </p>
        </section>
      </div>
    </div>
  );
};

export default UPSDobVerificationFailed;
